// Heritex Innovation – test ids
export const NAV = {
  root: 'site-nav',
  logo: 'nav-logo',
  linkServices: 'nav-link-services',
  linkProcess: 'nav-link-process',
  linkWork: 'nav-link-work',
  linkAbout: 'nav-link-about',
  linkContact: 'nav-link-contact',
  cta: 'nav-cta-contact',
  menuToggle: 'nav-menu-toggle',
};

export const HERO = {
  root: 'hero',
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
};

export const SERVICES = {
  root: 'services',
  row: (slug) => `service-row-${slug}`,
};

export const CONTACT = {
  root: 'contact',
  form: 'contact-form',
  name: 'contact-input-name',
  email: 'contact-input-email',
  phone: 'contact-input-phone',
  company: 'contact-input-company',
  projectType: 'contact-input-project-type',
  budget: 'contact-input-budget',
  message: 'contact-input-message',
  submit: 'contact-submit',
  success: 'contact-success',
  error: 'contact-error',
};

export const FOOTER = {
  root: 'site-footer',
  backToTop: 'footer-back-to-top',
};
